export const categoriesData = [
  {
    value: 1,
    title: "منطقه 1",

    subCategories: [
      {
        parent_id: 1,
        value: 1,
        title: "ولنجک",
      },
      {
        parent_id: 1,
        value: 2,
        title: "زعفرانیه",
      },
      {
        parent_id: 1,
        value: 3,
        title: "محمودیه",
      },
      {
        parent_id: 1,
        value: 4,
        title: "الهیه",
      },
      {
        parent_id: 1,
        value: 5,
        title: "فرشته",
      },
      {
        parent_id: 1,
        value: 6,
        title: "قیطریه",
      },
      {
        parent_id: 1,
        value: 7,
        title: "نیاوران",
      },
      {
        parent_id: 1,
        value: 8,
        title: "فرمانیه",
      },
      {
        parent_id: 1,
        value: 9,
        title: "لواسانات",
      },
    ],
  },
  {
    value: 2,
    title: "دبی",
  },
  {
    value: 3,
    title: "استانبول",
  },
];
